// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__xaMku","inner":"Footer_inner__358Qg"};